module.exports = __webpack_public_path__ + "img/shopping_application_4-2.3d3263fb.jpg";